export function allFirstLetterCap (text: string){
    return text.trim().toLowerCase().split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ');
}

export function trimAndLowerCase (text: string){
    return text.trim().toLowerCase();
}